const graphsTypes = {

  reset: "RESET_GRAPH",

  clear_dates: "CLEAR_GRAPH_DATES",

  get: {
    request: "GET_GRAPHS_REQUEST",
    success: "GET_GRAPHS_SUCCESS",
    failure: "GET_GRAPHS_FAILURE"
  },

}

export default graphsTypes



// WEBPACK FOOTER //
// ./src/js/constants/graphsTypes.js